export const WEB_URL_CONSTANTS = {
  HOMEPAGE: 'https://www.tinkerlust.com'
}
